import { Button, Form, message, Spin } from "antd";
import React, { useState, useEffect } from "react";
import { useForm } from "antd/lib/form/Form";
import TextInputField from "../components/components/checkout/elements/TextInputField";
import TextAreaField from "../components/components/checkout/elements/TextAreaField";
import TextEmailField from "../components/components/checkout/elements/TextEmailField";
import TextPhoneField from "../components/components/checkout/elements/TextPhoneField";
import TextDateField from "../components/components/checkout/elements/TextDateField";
import TextDayMonthField from "../components/components/checkout/elements/TextDayMonthField";
import SelectBoxField from "../components/components/checkout/elements/SelectBoxField";
import CheckBoxField from "../components/components/checkout/elements/CheckBoxField";
import RadioField from "../components/components/checkout/elements/RadioField";
import { apiCall } from "../components/utilities/Api";
import CSS from "../components/utilities/CSS";
import { getColor, getFontFamily } from "../util/CC";

export default function CustomForm(props) {

    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0 } = props;

    const [content, setContent] = useState(props.content);
    const template = window.sitesettings.template_info;


    const [f] = useForm();

    // Component agnostic
    const {
        location = "main",
        component = "blank_space",
        injected_data = {},
        container = true,
        data = {}
    } = content

    // Component specific
    const {
        form_id = "",
        width = 30,
        padding_x = 10,
        padding_y = 10,
        show_heading = true,
        heading_align = "center",
        heading_preset = 0,
        show_description = true,
        description_align = "center",
        description_preset = 0,
        align = "0 auto",
        label_preset = 0,
        label_help_preset = 0,
        label_description_preset = 0,
        input_font = 0,
        button_label = "Submit",
        button_type = 0,
        button_block = true,
        background_colour = 0,
        gap = 0,
        layout = "vertical",
    } = data;

    const form = useState(injected_data);
    const [sent, setSent] = useState(false);
    const [loading, setLoading] = useState(false);

    const submitForm = (_data) => {

        const entries = Object.entries(_data).map(([key, value]) => ({
            id: Number(key),
            value
        }));

        setLoading(true);
        apiCall("custom_form/submit", { form_id: form_id, data: JSON.stringify(entries) }, (_s, _r) => {
            if (_s) {
                message.success("Form sent successfully.")
            } else {
                message.error(_r.error)
            }
            setLoading(false);
            setSent(true);
        })
    }



    const drawElement = (_data) => {




        const _props = {
            label_description_class: "bm-txt-" + label_description_preset,
            label_help_class: "bm-txt-" + label_help_preset,
            label_class: "bm-txt-" + label_preset,
            form: f,
            data: _data,
            id: _data.id
        }

        switch (_data.type) {
            case "text":
                return (<TextInputField {..._props} />);
            case "textarea":
                return (<TextAreaField {..._props} />);
            case "email":
                return (<TextEmailField {..._props} />);
            case "phone":
                return (<TextPhoneField {..._props} />);
            case "date":
                return (<TextDateField {..._props} />);
            case "daymonth":
                return (<TextDayMonthField {..._props} />);
            case "select":
                return (<SelectBoxField {..._props} />);
            case "checkbox":
                return (<CheckBoxField {..._props} />);
            case "radio":
                return (<RadioField {..._props} />);
        }
    }


    const drawElements = (_formdata) => {
        return _formdata.elements.map(item => {
            return <div style={{ "width": (layout === "horizontal") ? "350px" : "100%" }}>{drawElement(item)}</div>;
        })
    }

    const drawCustomForm = () => {

        const _style = {
            background: getColor(background_colour, template),
        }

        const _align = {
            maxWidth: (1248 * (width / 100)) + "px",
            margin: align,
            padding: padding_y + "px " + padding_x + "px",
        }

        if (form) {
            return (
                <div style={_style}>

                    <div style={_align}>
                        <Form disabled={sent} onFinish={submitForm} form={f} layout={"vertical"}>
                            {(show_heading &&
                                <h3 style={{ "display": "block", "textAlign": heading_align }} className={"bm-txt-" + heading_preset} >
                                    {form.header}
                                </h3>
                            )}
                            {(show_description &&
                                <>
                                    <div style={{ "display": "block", "textAlign": description_align }} className={"bm-txt-" + description_preset} >{form.description}</div>
                                    <div className="shim" /><div className="shim" />
                                </>
                            )}
                            <div className="form-format" style={{ "display": "flex", "justifyContent": "center", "flexWrap": "wrap", "alignItems": "flex-start", "flexDirection": (layout === "vertical") ? "column" : "row", gap: gap }}>
                                {drawElements(form)}

                                <Button disabled={sent} htmlType="submit" block={button_block} className={"bm-btn-" + button_type + " nomargin"} >{button_label}</Button>
                            </div>
                        </Form>
                    </div>
                </div>
            )
        } else {
            return (<></>)
        }


    }

   

    let _class = ``;

    _class += `
         #bm-${id} input, #bm-${id} textarea, #bm-${id} .ant-select-selection-item {
           font-family: '${getFontFamily(input_font, template)}' !important;
         }
            #bm-${id} .ant-input-textarea-show-count::after{
             display:none; 
            }
         .inlineforce{
            display: inline !important;
         } 
            .nomargin{
  margin: 0 !important;
} 
         `;;

    const drawRender = () => {
        return (
            <>
                <CSS prepend html={_class} />
                <Spin spinning={loading}>
                    <div id={"bm-" + id} className={(container) ? "preview-container bm-form-component" : "bm-form-component"}>
                        {drawCustomForm()}
                    </div>
                </Spin>
            </>
        )
    }

    return (
        <>
            {drawRender()}
        </>
    )

}